import React, { useEffect } from "react";
import OppotunitiesCard from "./components/OpportunitiesCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpportunitiesForVendor } from "../../../redux/slices/vendorJobSlice";

const Opprtunities = () => {
  const dispatch = useDispatch();
  const { vendorId } = useSelector((state) => state.vendorAuth);
  const { data, loading, error } = useSelector((state) => state.vendorJob);
  useEffect(() => {
    if (vendorId) {
      dispatch(fetchOpportunitiesForVendor(vendorId));
    }
  }, [vendorId, dispatch]);
  return (
    <div>
      <OppotunitiesCard />
    </div>
  );
};

export default Opprtunities;
